import React from "react"
import { Skeleton } from "./skeleton"

interface SkeletonWrapperProps {
  loading: boolean
  className?: string
  skeletonClassName?: string
  skeletonStyle?: React.CSSProperties
  children: React.ReactNode
}

const SkeletonWrapper: React.FC<SkeletonWrapperProps> = ({
  loading,
  className,
  skeletonClassName,
  skeletonStyle,
  children
}) => {
  return (
    <div className={className} style={{ position: 'relative' }}>
      {/* Keep children mounted but hidden */}
      <div style={{ visibility: loading ? 'hidden' : 'visible' }}>
        {children}
      </div>

      {/* Show skeleton only when loading */}
      {loading && (
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Skeleton
            className={skeletonClassName}
            style={{
              width: '100%',
              height: '100%',
              ...skeletonStyle
            }}
          />
        </div>
      )}
    </div>
  )
}

export { SkeletonWrapper }